import { ComponentProps } from 'react';

import { x } from '@/style';

import { SurveyType } from '@graphql/requests';

import { ContactDetailsForm } from '@ui-furniture/common/contact-details-form';
import { StackDivider } from '@ui-furniture/common/stack-divider';
import { Stack, Text, VStack } from '@ui-furniture/elements';
import { Modal } from '@ui-furniture/lib/modal';
import { ModalControls } from '@ui-furniture/lib/modal/types/controls';

import { accessFormDetails } from './access-form';
// eslint-disable-next-line import/no-cycle
import { SpecialistSurveyCard } from './specialist-survey-card';

import { surveyData } from '../common/survey-data';
import { useSurveyRecommendation } from '../context/survey-recommendation';
import { useBookSurvey } from '../hooks/use-book-survey';

const BookSpecialistSurveyContent = ({ type }: { type: SurveyType }) => {
  const data = surveyData.specialistSurveys.find(
    (survey) => survey.type === type
  )!;
  const { recommendation } = useSurveyRecommendation();
  if (!recommendation)
    throw new Error('Cannot book a survey without a recommendation');

  const bookSurvey = useBookSurvey({
    surveyType: type,
    quotedPrice: data.price || undefined,
  });

  return (
    <VStack gap='2xl'>
      <VStack gap='xl'>
        <Text variant='subTitle' textAlign='center'>
          Book Your Report
        </Text>
        <Stack gap='xl' flexDirection={{ _: 'column', phablet: 'row' }}>
          <VStack maxW='280px' gap='lg'>
            <x.div pointerEvents='none' w='100%'>
              <SpecialistSurveyCard {...data} />
            </x.div>
            <VStack gap='sm'>
              <Text fontWeight='600'>What is it?</Text>
              <Text variant='bodySmall'>{data.description}</Text>
            </VStack>
          </VStack>
          <StackDivider />
          <VStack flex='1' gap='lg'>
            <Text variant='bodySmall'>
              Confirm your contact details and a member of our team will be in
              touch to discuss your requirements and book it for a time that
              suits you.
            </Text>

            <StackDivider />
            <ContactDetailsForm
              formProps={{
                isPhoneOptional: false,
              }}
              handleSubmit={bookSurvey}
              additionalForm={accessFormDetails}
            />
          </VStack>
        </Stack>
      </VStack>
    </VStack>
  );
};

export const BookSpecialistSurveyModal = ({
  controls,
  ...rest
}: {
  controls: ModalControls;
} & ComponentProps<typeof BookSpecialistSurveyContent>) => (
  <Modal
    controls={controls}
    variant='popover'
    contentProps={{
      w: 'auto',
      maxWidth: 'content-width',
    }}
  >
    <BookSpecialistSurveyContent {...rest} />
  </Modal>
);
